import React, { useContext, useEffect, useState } from 'react'
import AuthLayout from '../../custom/components/templates/AuthLayout'
import { useHistory, Link } from 'react-router-dom'
import { handleRedirectInternal } from '@/product/common/components'
import AuthContext from '@/product/context/auth/authContext'
import { useTranslation } from 'react-i18next'
import LoginComponent from './loginComponent'
import { loginSchema } from './loginSchema'
import SEO from '@/utils/SEO'
import { useFormik } from 'formik'
import './Login.css'
import { IconButton } from '@material-ui/core'
//login page
const Login = () => {
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const vData = loginSchema()
    //useTranslation for language change functionality
    const { t } = useTranslation()

    const { login, responseStatus, clearResponse, isAuthenticated, user } = authContext
    const [userLogged, setUserLogged] = useState(false)

    const formik = useFormik({
        initialValues: vData.initialValues,
        validationSchema: vData.validationArray,
        onSubmit: (values) => {
            if (values.remember_me) {
                localStorage.email = values.email
                localStorage.password = values.password
                localStorage.remember_me = values.remember_me
            } else {
                delete localStorage.email
                delete localStorage.password
                delete localStorage.remember_me
            }

            login(values)
        },
    })

    const handleredirection = () => {
        localStorage.setItem('user_added', 1)
        setUserLogged(true)
    }

    // useEffect(() => {
    //     if (isAuthenticated && user && userLogged) {
    //         handleRedirectInternal(history, user?.admin ? 'seller/dashboard' : '')
    //     }
    // }, [isAuthenticated, user])

    return (
        <>
            <SEO
                title={t('login')}
                description="Shop on Zipperbuy - Find great deals. Buy now or make offers on new, overstock, open-box, and returned items. Shop local, save money."
                keywords="deals, buy now, overstock, open-box, returned items, shop local, shopping, marketplace, auctions, offers"
                url={window.location.href}
            />
            <AuthLayout
                title="HELLO"
                // authNote="Don't have an account?"
                // authLink="/registration"
                authText="Create an Account"
                seperatorText="Or"
                login={login}
                formik={formik}
                googleLogin={true}
                facebookLogin={true}
                rememberMe={vData.rememberMe}
            >
                <LoginComponent
                    formik={formik}
                    rememberMe={vData.rememberMe}
                    loginInfo={vData.login.formData}
                    onSuccess={handleredirection}
                />
            </AuthLayout>
        </>
    )
}

export default Login
